import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
//import { Router, ActivatedRoute, Params } from "@angular/router";
import {FlashMessagesService} from 'angular2-flash-messages';

import 'rxjs/add/operator/toPromise';

import {URL_API} from './../constante';
import {HEADERS} from './../constante';
import {Utils} from '../shared/utils';

import {Usuario} from '../usuario/usuario';

@Injectable()
export class AcessoService {

    usuario: Usuario;

    private url_api = URL_API + '/login';

    login(usuario: Usuario): Promise<Response>{
        return this.http
            .post(this.url_api, JSON.stringify(usuario), {headers: HEADERS})
            .toPromise()
            .then(res=>res.json())
            .catch(error => this.utils.handleError(error));
    }

    setUsuario(usuario) {
        sessionStorage.setItem('nome',usuario.nome),
        sessionStorage.setItem('email',usuario.email),
        sessionStorage.setItem('api_token',usuario.api_token),
        sessionStorage.setItem('id',usuario.id)
        sessionStorage.setItem('perfil',usuario.perfilsys_id)

    }

    getUsuario() {
        return {
            nome:  sessionStorage.getItem('nome'),
            email: sessionStorage.getItem('email'),
            api_token: sessionStorage.getItem('api_token'),
            id: sessionStorage.getItem('id')
    }
    }

    constructor(private http: Http,
				private flashMessagesService: FlashMessagesService,
                private utils: Utils) {
    }

    


}



// WEBPACK FOOTER //
// ./src/app/acesso/acesso.service.ts